module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"a":"Une erreur est survenue"},"en":{"a":"An error occured"}}')
  delete Component.options._Ctor
}
